<template>
  <div class="scholar-search" >
    <!-- 侧边栏 -->
<!--    <sidebar />-->

    <!-- 内容 -->
    <div class="content" style="flex: 1">
      <!-- 新建会话 -->
      <div class="infor" v-if="$route.name === 'scholarSearch'">
        <h1 class="title">
          <scholarIcon
            width="55px"
            :fill="'#ffffff'"
          />
          <span>专家查询</span>
        </h1>
        <p class="tips">用于分析某位学者画像及成果发表情况</p>
        <div class="search-box" >
          <textareaComp :rows-number="4" ref="textAreaRef"/>
        </div>

        <!--  推荐问题  -->
        <div class="recommends-list">
          <p
            class="item"
            v-for="(item, index) in recommendData"
            :key="index"
            @click="handleClickRecommend(item)"
          >
            <scholarIcon
              v-if="item.type === '1'"
              width="22px"
              height="22px"
              :fill="'#2F70FF'"
            />
            <questionIcon
              v-if="item.type === '2'"
              width="18"
              height="18"
              :fill="'#14D07A'"
            />
            <literatureIcon
              v-if="item.type === '3'"
              width="16"
              height="16"
              :fill="'#DDA726'"
            />
            <span>{{ item.question }}</span>
          </p>
        </div>

        <div class="recommends-scholar" v-loading="loading">
          <h3>为您推荐</h3>
          <SearchScholarList
            ref="SearchScholarList"
            :person-list="talentData"
            :city-type="talentLocationValue"
          />
        </div>

<!--        <homeRecommend :startPlay="showMoreContent" />-->
      </div>
      <!-- 专家查询历史会话 -->
      <div v-else class="history-list">
        <historyChat />
      </div>
    </div>
  </div>
</template>

<script>
import textareaComp from '@/views/scholarSearch/comps/textareaComp.vue';
import historyChat from '@/views/scholarSearch/comps/historyChat.vue';
import homeRecommend from '@/views/scholarSearch/comps/homeRecommend.vue'
import scholarIcon from '@/assets/images/home/btn1.svg';
import SearchScholarList from '@/views/scholarSearch/comps/searchScholarList.vue';
import { scholarSearchMixin } from '@/mixin/scholarSearch/scholarSearchMixin';

export default {
  mixins: [ scholarSearchMixin ],
  name: 'scholarSearch',
  components: {
    scholarIcon,
    textareaComp,
    historyChat,
    homeRecommend,
    SearchScholarList,
  },
  props: {},
  data () {
    return {}
  },
  created () {},
  methods: {},
}
</script>

<style scoped lang="less">
.scholar-search {
  box-sizing: border-box;
  display: flex;
  // min-height: calc(100vh - 100px);

  .search-box {
    margin: 0 auto;
    width: 80%;
    min-width: 580px;
    max-width: 1080px;
    padding-top: 20px;
  }

  .content {
    .infor {
      background: url("~@/assets/images/talent/bg.png") no-repeat;
      background-size: 100% 500px;
      overflow: hidden;
    }

    .title {
      margin-top: 50px;
      height: 60px;
      font-size: 32px;
      color: #555;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 2px;

      span {
        margin-left: 16px;
        color: #FFFFFF;
      }
    }
    p.tips {
      margin-top: 10px;
      font-weight: 500;
      color: #FFFFFF;
      font-size: 16px;
      text-align: center;
    }
  }

  .history-list {
    /*height: calc(100vh - 280px) ;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 20px 20px 0;*/
  }
}

.recommends-list {
  width: 1100px;
  font-size: 14px;
  color: #666666;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 40px auto;

  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ffffff;
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 8px #6874ad40;
    background-color: #ffffff;
    margin: 15px 10px;

    &:hover {
      background-color: #f6f8fd;
    }
  }
}

.recommends-scholar {
  width: 1400px;
  margin: 70px auto 30px;

  h3 {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
